module.exports = __webpack_public_path__ + "img/f6.ba2931fa.png";